import { DocumentUserAssignment } from '../../../../types';
import { InceptHeader } from '../../../constants/InceptHeader';
import { ConstructPost } from '../../../types/ConstructPost';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { APPLICATION_BASE_PATH } from '../constants/applicationBasePath';

export const postAssignApplicationUser = async (
  constructPost: ConstructPost,
  uuid: string,
  definitionName: string,
  userId: string,
): Promise<NonPaginatedResponse<DocumentUserAssignment> | undefined> =>
  constructPost(
    `${APPLICATION_BASE_PATH}/${uuid}/assignments/create`,
    {
      data: { user_id: userId },
      headers: {
        [InceptHeader.DefinitionName]: definitionName,
      },
    },
    { preventDefaultErrorToast: true },
  );
